import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SummaryService } from '../summary/summary.service';
import { AxGridComponent, AxChartComponent } from '../../../shared/components';
import { AxPivotGridComponent } from 'src/app/shared/components/pivot-grid/pivot-grid.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})

export class SummaryComponent implements AfterViewInit {
  @ViewChild(AxChartComponent) chart!: AxChartComponent;
  @ViewChild(AxGridComponent) grid!: AxGridComponent;

  /*
  seriesNames: any[] = [
    {
      name: "Portfolio",
      value: "portTotalReturn"
    },
    {
      name: "Benchmark",
      value: "benchTotalReturn"
    }
  ];
  */

  constructor(
    public summary: SummaryService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngAfterViewInit() {
    //this.chart.argumentField = 'beginDate';

    this.chart.series = [
      {
        type: 'line',
        argumentField: 'beginDate',
        valueField: 'portTotalReturn',
        name: 'Portfolio'
      },
      {
        type: 'line',
        argumentField: 'beginDate',
        valueField: 'benchTotalReturn',
        name: 'Benchmark'
      }
    ];

    this.chart.argumentAxis = {
      argumentType: 'datetime',
      tickInterval: {
        days: 1
      },
      label: {
        format: {
          type: 'shortDate'
        }
      }
    };

    this.grid.columns = [
      {
        dataField: 'beginDate',
        dataType: 'date',
        caption: 'Date',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'portTotalReturn',
        dataType: 'number',
        caption: 'Portfolio Total Return',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'benchTotalReturn',
        dataType: 'number',
        caption: 'Benchmark Total Return',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'yAllocationHigh',
        dataType: 'number',
        caption: 'Allocation High',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'yAllocationLow',
        dataType: 'number',
        caption: 'Allocation Low',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'ySelectionEffect',
        dataType: 'number',
        caption: 'Selection Effect',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'yFundResidual',
        dataType: 'number',
        caption: 'Fund Residual',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      },
      {
        dataField: 'yActiveCurrencyReturn',
        dataType: 'number',
        caption: 'Active Currency Return',
        format: '#,##0.000',
        headerCellTemplate: 'titleHeaderTemplate'
      }
    ];

    //let id = this.route.snapshot.paramMap.get('id');
    this.chart.showLoadingIndicator();
    this.grid.showLoadingIndicator();
    this.summary.retrieve().subscribe(
      data => {
        let jsonObj = JSON.parse(data);
        this.chart.dataSource = jsonObj;
        this.grid.dataSource = jsonObj;
        let bdate = jsonObj.slice(-1)[0].beginDate;
        this.summary.analysisDate = new Date(bdate);
      })
      .add(() => {
        this.chart.hideLoadingIndicator();
        this.grid.hideLoadingIndicator();
      });
  }

  /* 2020-10-05 james: detail view would be always in total period, so there is no need to
   * click on the specific chart point on specific date. It should allow user to click on any points
   * in the series
  pointClickedHandler(e: any) {
    var point = e.target;
    this.summary.analysisDate = new Date(point.argument);
    this.summary.seriesName = point.series.name;
    this.router.navigate(['/rv-detail', '' + this.summary.reportId, this.summary.analysisDate.toISOString(), point.series.name]);
  }
  */

  seriesClicked(e: any) {
    let series = e.target;
    this.summary.seriesName = series.name;
    // the analysis date will be ignore becuase it's only showing the T rows
    this.router.navigate(['/rv-detail', '' + this.summary.reportId, this.summary.analysisDate!.toISOString(), series.name]);
  }
}

/* heatmap testing
import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SummaryService } from '../summary/summary.service';
import { AxGridComponent, AxChartComponent } from '../../../shared/components';
import { AxHeatmapComponent } from 'src/app/shared/components/heatmap/heatmap.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})

export class SummaryComponent implements AfterViewInit {
  @ViewChild(AxChartComponent) chart: AxChartComponent;
  @ViewChild(AxHeatmapComponent) grid: AxHeatmapComponent;

  constructor(
    public summary: SummaryService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngAfterViewInit() {
    //this.chart.argumentField = 'beginDate';

    this.chart.series = [
      {
        type: 'line',
        argumentField: 'beginDate',
        valueField: 'portTotalReturn',
        name: 'Portfolio'
      },
      {
        type: 'line',
        argumentField: 'beginDate',
        valueField: 'benchTotalReturn',
        name: 'Benchmark'
      }
    ];

    this.chart.argumentAxis = {
      argumentType: 'datetime',
      tickInterval: {
        days: 1
      },
      label: {
        format: {
          type: 'shortDate'
        }
      }
    };

    this.grid.columns = [
      {
        dataField: 'beginDate',
        dataType: 'date',
        caption: 'Date',
        width: 100,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'portTotalReturn',
        dataType: 'number',
        caption: 'Portfolio Total Return',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'benchTotalReturn',
        dataType: 'number',
        caption: 'Benchmark Total Return',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'yAllocationHigh',
        dataType: 'number',
        caption: 'Allocation High',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'yAllocationLow',
        dataType: 'number',
        caption: 'Allocation Low',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'ySelectionEffect',
        dataType: 'number',
        caption: 'Selection Effect',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'yFundResidual',
        dataType: 'number',
        caption: 'Fund Residual',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      },
      {
        dataField: 'yActiveCurrencyReturn',
        dataType: 'number',
        caption: 'Active Currency Return',
        format: '#,##0.000',
        width: 55,
        headerCellTemplate: 'titleHeaderTemplate',
        cellTemplate: 'buttonCellTemplate'
      }
    ];

    //let id = this.route.snapshot.paramMap.get('id');
    this.chart.showLoadingIndicator();
    this.grid.showLoadingIndicator();
    this.summary.retrieve().subscribe(
      data => {
        this.chart.dataSource = data;
        this.grid.dataSource = data;
        let bdate = data.slice(-1)[0].beginDate;
        this.summary.analysisDate = new Date(bdate);
      })
      .add(() => {
        this.chart.hideLoadingIndicator();
        this.grid.hideLoadingIndicator();
      });
  }


  seriesClicked(e: any) {
    let series = e.target;
    this.summary.seriesName = series.name;
    // the analysis date will be ignore becuase it's only showing the T rows
    this.router.navigate(['/rv-detail', '' + this.summary.reportId, this.summary.analysisDate.toISOString(), series.name]);
  }
}

*/
